module.exports = __webpack_public_path__ + "img/navbar_logo@3x.3941ac22.png";